// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__uYXjr","cabecalho":"NavBar_cabecalho__O-x0D","image":"NavBar_image__0k6tE","navbar":"NavBar_navbar__LzazH","item2":"NavBar_item2__KhTuE"};